<template>
  <div class="flex h-full flex-col">
    <div
      class="mb-4 flex flex-col items-center justify-between gap-8 py-2 md:flex-row-reverse"
    >
      <div
        class="flex flex-col items-center justify-between gap-2 md:flex-row"
      >
        <DateFilter
          :model-value="globalQuery"
          :time-period-label="timePeriodLabel"
          range-type="custom"
          @update:model-value="setGlobalQuery"
        />
      </div>
    </div>

    <QueryLoading v-if="isLoading" />
    <QueryError
      v-else-if="error"
      :show-retry="true"
      class="m-auto"
      @retry="refetch"
    >
      Failed to load Transaction Report

      <template v-if="isErrorDatabaseTimeout">
        <br />
        <span class="font-normal">
          The request took too long to process, try a
          smaller date range.
        </span>
      </template>
    </QueryError>

    <!-- Fetched populated data  -->
    <template v-else-if="transactions.length > 0">
      <TransactionsList :transactions="transactions" />

      <div class="mb-4 flex justify-around px-8">
        <BasePagination
          v-model:page="page"
          :enable-next="enableNext"
          :enable-previous="enablePrevious"
        />
      </div>
    </template>

    <!-- Fetched empty data -->
    <div v-else class="m-auto text-center">
      <p class="font-semibold"> No transactions found. </p>
      <p> Try changing the date range. </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ApiError } from "@/api"

const { globalQuery, setGlobalQuery, timePeriodLabel } =
  useReportQuery({})

const {
  enableNext,
  enablePrevious,
  paginationQuery,
  page,
  resetPagination,
} = useHasNextPagination({
  hasNext: computed(() => data.value?.hasNext ?? false),
  limit: 10,
})

watch(
  () => [globalQuery],
  () => resetPagination(),
  { deep: true, immediate: true }
)
const query = reactiveComputed(() => ({
  ...globalQuery.value,
  ...paginationQuery.value,
}))
const { data, error, refetch, isLoading } =
  useTransactions(query)

const transactions = computed(() => data.value?.items ?? [])

const isErrorDatabaseTimeout = computed(
  () =>
    error.value instanceof ApiError &&
    error.value.code === "database-timeout"
)
</script>
